  (function(){
    function ready(fn){(document.readyState==='loading')?document.addEventListener('DOMContentLoaded',fn):fn();}

    function buildModal(){
      if(document.getElementById('ig-sip-modal')) return;

      var back = document.createElement('div');
      back.className='ig-sip__backdrop'; back.setAttribute('data-ig-hidden',''); back.setAttribute('data-sip-backdrop','');

      var modal = document.createElement('div');
      modal.className='ig-sip__modal'; modal.id='ig-sip-modal';
      modal.setAttribute('data-ig-hidden',''); modal.setAttribute('role','dialog'); modal.setAttribute('aria-modal','true');

      var card = document.createElement('div');
      card.className='ig-sip__card'; card.setAttribute('role','document');
      card.innerHTML =
        '<header class="ig-sip__hd">' +
          '<h3 class="ig-sip__ttl">Shopper Identity Protection — Details</h3>' +
          '<button type="button" class="ig-sip__x" data-sip-close aria-label="Close">×</button>' +
        '</header>' +
        '<div class="ig-sip__bd">' +
          '<p><strong>What you get:</strong> Complimentary Shopper Identity Protection (up to $100,000) with every order.</p>' +
          '<p><strong>How it helps:</strong> Added peace of mind for identity theft recovery and related costs.</p>' +
          '<p><a class="ig-sip__link" href="/pages/complimentary-shopper-identity-protection" target="_blank" rel="noopener">View the full page</a></p>' +
        '</div>' +
        '<footer class="ig-sip__ft">' +
          '<button type="button" class="ig-sip__btn" data-sip-close>Close</button>' +
        '</footer>';

      modal.appendChild(card);
      document.body.appendChild(back);
      document.body.appendChild(modal);

      function hide(){ modal.setAttribute('data-ig-hidden',''); back.setAttribute('data-ig-hidden',''); document.removeEventListener('keydown', onKey); }
      function onKey(e){ if(e.key==='Escape'){ e.preventDefault(); hide(); } }

      back.addEventListener('click', hide);
      modal.querySelectorAll('[data-sip-close]').forEach(function(b){ b.addEventListener('click', hide); });

      window.IG_SIP = window.IG_SIP || {};
      window.IG_SIP.open = function(){
        back.removeAttribute('data-ig-hidden');
        modal.removeAttribute('data-ig-hidden');
        document.addEventListener('keydown', onKey);
        (modal.querySelector('[data-sip-close]')||modal).focus();
      };
    }

    function norm(s){ return (s||'').toLowerCase().replace(/[\u2013\u2014\-]+/g,'—').replace(/\s+/g,' ').trim(); }

    var NEEDLE_A='trustedsite shopper identity protection', NEEDLE_B='free with every order', PS_TEXT='please shop confidently';

    function findContainer(){
      var candidates = Array.from(document.querySelectorAll('.product__page--info, .rte, .page-width, main, body *'));
      var best=null;
      candidates.forEach(function(el){
        if(!el || !el.innerText) return;
        var t=norm(el.innerText);
        if(t.indexOf(NEEDLE_A)!==-1 && t.indexOf(NEEDLE_B)!==-1 && t.indexOf(PS_TEXT)!==-1){
          if(!best || el.innerText.length<best.innerText.length) best=el;
        }
      });
      return best;
    }

    function nearestLinkRef(fromEl){
      return (
        (fromEl && fromEl.closest('.product__page--info') && fromEl.closest('.product__page--info').querySelector('a')) ||
        document.querySelector('.product__page--info a') ||
        document.querySelector('.rte a') ||
        document.querySelector('.page-width a') ||
        document.querySelector('main a')
      );
    }

    function styleLikeLink(el, ref){
      if(!el || !ref) return;
      var cs = getComputedStyle(ref);
      el.style.cssText = [
        'cursor:pointer','background:none','border:0',
        'color:'+cs.color,
        'font:inherit',
        'text-decoration-line:'+cs.textDecorationLine,
        'text-decoration-style:'+cs.textDecorationStyle,
        'text-decoration-color:'+(cs.textDecorationColor||cs.color),
        'text-underline-offset:'+cs.textUnderlineOffset
      ].join(';')+';';
    }

    function injectDetails(){
      if(document.getElementById('ig-sip-details')) return;

      var container = findContainer();
      if(!container) return;

      var it = document.createNodeIterator(container, NodeFilter.SHOW_TEXT);
      var n, rx = /free with every order\.?/i;
      while((n = it.nextNode())){
        if(!n.nodeValue) continue;
        var m = n.nodeValue.match(rx);
        if(m){
          var parent = n.parentNode;
          var before = n.nodeValue.slice(0, m.index + m[0].length).replace(/\s+$/,'');
          var after  = n.nodeValue.slice(m.index + m[0].length);

          var beforeNode = document.createTextNode(before + ' ');
          var link = document.createElement('a');
          link.href = '#';
          link.id = 'ig-sip-details';
          link.textContent = 'Details';
          link.setAttribute('aria-label','Shopper Identity Protection details');

          var afterNode = document.createTextNode(' ' + String(after||'').replace(/^\s+/, ''));

          parent.insertBefore(beforeNode, n);
          parent.insertBefore(link, n);
          parent.insertBefore(afterNode, n);
          parent.removeChild(n);

          styleLikeLink(link, nearestLinkRef(link));
          link.addEventListener('click', function(e){ e.preventDefault(); buildModal(); window.IG_SIP && IG_SIP.open && IG_SIP.open(); });

          return;
        }
      }

      var it2 = document.createNodeIterator(container, NodeFilter.SHOW_TEXT);
      var t2, rxPs=/please shop confidently/i;
      while((t2 = it2.nextNode())){
        if(t2.nodeValue && rxPs.test(t2.nodeValue)){
          var p = t2.parentNode;
          var space = document.createTextNode(' ');
          var a = document.createElement('a');
          a.href='#'; a.id='ig-sip-details'; a.textContent='Details';
          a.setAttribute('aria-label','Shopper Identity Protection details');
          p.insertBefore(space, t2);
          p.insertBefore(a, t2);
          styleLikeLink(a, nearestLinkRef(a));
          a.addEventListener('click', function(e){ e.preventDefault(); buildModal(); window.IG_SIP && IG_SIP.open && IG_SIP.open(); });
          return;
        }
      }
    }

    ready(function(){
      buildModal();
      injectDetails();
      setTimeout(injectDetails, 400);
    });
  })();
  